<div class="topaz-wrapper">
  <topaz-global-bar style="z-index:999;" *ngIf="isGlobalbar || !prelogin"
    customLogoImg="assets/icons/PearonEvolutionLogo.png" class="global-bar-position" logoAltText="Pearson home"
    id="barWithLogo" (click)="backto()">

    <topaz-global-bar-start>
      <h1 class="topaz-title"
          style="font-family:Plus Jakarta Sans !important;margin-top:20px;color:#fff;line-height:100%;letter-spacing:0.5px;font-weight:600;font-size:20px">Microsoft
          Certified Trainer Portal</h1>
    </topaz-global-bar-start>
    <topaz-global-bar-end>

      <a *ngIf="isAbout" href="javascript:void(0)" style="cursor:pointer;padding-right:40px;margin-top:18px;color:#fff;text-decoration:none" (keydown.enter)="fee()"
          (keydown.space)="fee()"; (click)="fee();$event.stopPropagation()">About the program</a>
      
      <a *ngIf="isAbout" href="javascript:void(0)" style="cursor:pointer;margin-top:10px;color:#fff;padding-left:5px;text-decoration:none" (keydown.enter)="onSignin()"
          (keydown.space)="onSignin()"; (click)="onSignin();$event.stopPropagation()"><fa-icon *ngIf="isAbout" style="margin-right:5px;margin-bottom:10px;" size="lg" [icon]="icons.faUser" aria-hidden="true"></fa-icon><span style="top:3px;position:relative">Sign in</span></a>
      <!-- <fa-icon *ngIf="isAbout" style="padding-left:12px;padding-right:0 !important;" id="userMenuChevron" [icon]="icons.faCaretDown" aria-hidden="true"></fa-icon> -->
      <button aria-label="User account menu" *ngIf="prelogin" mat-button [matMenuTriggerFor]="accountMenu"
        aria-haspopup="menu" id="dynamicTriggerForJane">
        <fa-icon size="lg" [icon]="icons.faUser" aria-hidden="true"></fa-icon>
        <span id="userName"
          style="padding-left:12px;font-weight:400;line-height:100%;letter-spacing:0px;font-family:Plus Jakarta Sans !important;font-size:16px">{{window.sessionStorage.getItem('name')==='null'?'':window.sessionStorage.getItem('name')}}</span>
        <fa-icon id="userMenuChevron" [icon]="icons.faChevronDown" aria-hidden="true"></fa-icon>
      </button>

      <mat-menu #accountMenu="matMenu" id="dynamicMenu" aria-label="Account options">
        <ng-template matMenuContent style="background-color: #fff;">
          <ng-container
            *ngIf="status != 'ILT_OPEN' && status != 'OPEN' && status != 'REINSTATE_APPROVE' && status != 'REINSTATE_SUBMIT' && status != 'REINSTATE_REJECT' && status != 'EXPIRED' && status != 'FIRST_LOGIN' && status != 'REJECT'">
            <button mat-menu-item *ngIf="profile && !main" aria-label="My profile" routerLink="/mycompany"
              [queryParams]="{ partnerId:partnerId,app:app }" skipLocationChange><fa-icon [icon]="icons.faBuilding"
                aria-hidden="true"></fa-icon>&nbsp;&nbsp;
              My profile</button>
          </ng-container>


          <button mat-menu-item *ngIf="main && spp" aria-label="Return to admin" (click)=view()><fa-icon
              [icon]="icons.faUserGear" aria-hidden="true"></fa-icon>&nbsp;&nbsp;Return to admin</button>
          <button (click)=logout() mat-menu-item aria-label="Log out"> <fa-icon [icon]="icons.faArrowRightFromBracket"
              aria-hidden="true"></fa-icon>
            &nbsp;&nbsp;Log out</button>
        </ng-template>
      </mat-menu>
    </topaz-global-bar-end>

  </topaz-global-bar>
  <topaz-sidenav *ngIf="isGlobalbar && main" class="admin-sidenav" [navItems]="adminMenuItems"></topaz-sidenav>
  <div class="topaz-content-wrapper">
      <mat-sidenav-container class="sidenav-container">
        <mat-sidenav *ngIf="isGlobalbar && user" mode="side" opened #sidenav class="primary-color mct_user_sidenav"
          [class.is-collapsed]="!isExpanded">
          <button mat-icon-button (click)="toggleSidenav()" class="toggle-btn" [class.align-right]="isExpanded"
            [class.align-left]="!isExpanded" [attr.aria-expanded]="isExpanded"
            [attr.aria-label]="isExpanded ? 'Collapse navigation menu' : 'Expand navigation menu'">
            <fa-icon [icon]="isExpanded ? icons.faAngleLeft : icons.faAngleRight"></fa-icon>
          </button>
          <mat-nav-list class="nav-list">
            <a mat-list-item [routerLinkActive]="'active-link'" [routerLink]="'/home'" class="navText"><fa-icon
                [icon]="icons.faGrid2" class="right" aria-hidden="true" />
              <div class="nav-text">Home</div>
            </a>
            <mat-divider style="border-color: #DFE1E1;margin-bottom:10px"></mat-divider>
             <h2 mat-subheader class="left menuText">MCT SUBSCRIPTION</h2>
            <a mat-list-item [routerLinkActive]="!isPayDisabled ? 'active-link' : ''" [class.disabled]="isPayDisabled"
              [routerLink]="isPayDisabled ? null : '/live'" [attr.aria-disabled]="isPayDisabled"
              [attr.tabindex]="isPayDisabled ? -1 : null" class="navText"><fa-icon [icon]="icons.faCreditCard"
                aria-hidden="true" class="right" />
              <div class="nav-text">Pay Subscription</div>
            </a>


            <a *ngIf="status!='ALUMNI' && alumniStatus!='APPROVAL'" mat-list-item
              [routerLinkActive]="!isLinkDisabled ? 'active-link' : ''" [class.disabled]="isLinkDisabled"
              [routerLink]="isLinkDisabled ? null : '/vouchers'" [attr.aria-disabled]="isLinkDisabled"
              [attr.tabindex]="isLinkDisabled ? -1 : null" class="navText"><fa-icon [icon]="icons.faMoneyCheckDollarPen"
                class="right" aria-hidden="true" />
              <div class="nav-text">Request Renewal</div>
            </a>

            <a *ngIf="status=='ALUMNI'" mat-list-item [routerLinkActive]="'active-link'"
              [routerLink]="'/reinstatement-mct'" class="navText"><fa-icon [icon]="icons.faMoneyCheckDollarPen"
                aria-hidden="true" class="right" />
              <div class="nav-text">Reinstate MCT</div>
            </a>

            <a *ngIf="status!='ALUMNI' && !isAlumniDisabled" mat-list-item
              [routerLinkActive]="!isLinkDisabled ? 'active-link' : ''" [class.disabled]="isLinkDisabled"
              [routerLink]="isLinkDisabled ? null : '/alumni-request'" [attr.aria-disabled]="isLinkDisabled"
              [attr.tabindex]="isLinkDisabled ? -1 : null" class="navText"><fa-icon [icon]="icons.faMoneyCheckDollarPen"
                class="right" aria-hidden="true" />
              <div class="nav-text">Alumni Request</div>
            </a>


            <mat-divider style="border-color: #DFE1E1;margin-bottom:10px"></mat-divider>
              <h2 mat-subheader class="left menuText">BENEFITS</h2>
            <a mat-list-item [routerLinkActive]="!isDisabled && !isLoungeDisabled  ? 'active-link' : ''"
              [class.disabled]="isDisabled && isLoungeDisabled"
              [routerLink]="isDisabled && isLoungeDisabled ? null : '/tech-communities'"
              [attr.aria-disabled]="isDisabled && isLoungeDisabled"
              [attr.tabindex]="(isDisabled && isLoungeDisabled) ? -1 : null" class="navText"><fa-icon
                [icon]="icons.faGear" class="right" aria-hidden="true" />
              <div class="nav-text">MCT Lounge</div>
            </a>
            <a mat-list-item [routerLinkActive]="!isDisabled ? 'active-link' : ''" [class.disabled]="isDisabled"
              [routerLink]="isDisabled ? null : '/vss'" [attr.aria-disabled]="isDisabled"
              [attr.tabindex]="isDisabled ? -1 : null" class="navText"><fa-icon [icon]="icons.faDisplayCode"
                aria-hidden="true" class="right" />
              <div class="nav-text">VS Subscription</div>
            </a>
            <a mat-list-item [routerLinkActive]="!isDisabled ? 'active-link' : ''" [class.disabled]="isDisabled"
              [routerLink]="isDisabled ? null : '/courseware'" [attr.aria-disabled]="isDisabled"
              [attr.tabindex]="isDisabled ? -1 : null" class="navText"><fa-icon [icon]="icons.faGraduationCap"
                aria-hidden="true" class="right" />
              <div class="nav-text">Learning Download Center</div>
            </a>
            <a mat-list-item [routerLinkActive]="!isDisabled ? 'active-link' : ''" [class.disabled]="isDisabled"
              [routerLink]="isDisabled ? null : '/extreme-labs'" [attr.aria-disabled]="isDisabled"
              [attr.tabindex]="isDisabled ? -1 : null" class="navText"><fa-icon [icon]="icons.faFlask"
                aria-hidden="true" class="right" />
              <div class="nav-text">Lab Access</div>
            </a>
            <mat-divider style="border-color: #DFE1E1;margin-bottom:10px"></mat-divider>

             <h2 mat-subheader class="left menuText">SUPPORT</h2>
            <a routerLinkActive="active-link" mat-list-item routerLink="/support"><fa-icon
                [icon]="icons.faMessagesQuestion" class="right" aria-hidden="true" />
              <div class="nav-text">Contact Support Team</div>
            </a>
          </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
          <main class="topaz-content">
          <router-outlet></router-outlet>
          </main>
        </mat-sidenav-content>
      </mat-sidenav-container>

 

  </div>

  <topaz-footer *ngIf="isGlobalbar || !prelogin">
    <topaz-footer-links>
      <ul>
        <li><a style="color:#512EAB" aria-label="Terms of Service" href="https://www.pearsonvue.com/us/en/legal/terms-of-service.html" target="_blank"
            rel="noopener noreferrer">Terms</a></li>
        <li><mat-divider [vertical]="true"></mat-divider></li>
        <li><a style="color:#512EAB" aria-label="Privacy and Cookies Policy" href="https://www.pearsonvue.com/us/en/legal/privacy-and-cookies-policy.html" target="_blank"
            rel="noopener noreferrer">Privacy</a>
        </li>
        <li><mat-divider [vertical]="true"></mat-divider></li>
        <li>
          <div class="cookiesWrapper">
            <a style="color:#512EAB" href="mailto:mctpvsupport@pearson.com" aria-label="Email MCT Support at mctpvsupport@pearson.com">Contact Us</a>
          </div>
        </li>
      </ul>
    </topaz-footer-links>
    <topaz-footer-copyright>
      <p>
        <span [style.display]="'inline-block'">
          Copyright {{ year }} Pearson Education Inc. or its affiliate(s).
        </span>
        <span [style.display]="'inline-block'">
          &nbsp; All rights reserved.
        </span>
      </p>
    </topaz-footer-copyright>
  </topaz-footer>

</div>

<!-- Topas Toaster Componenet  -->
<topaz-toaster></topaz-toaster>